/* Gourmet E-Liquid – stock & dispatch countdown (UK time) */
(function () {
  if (customElements.get('gel-dispatch')) return;
  var DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  function londonNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var map = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
    return { day: map[get('weekday')] || 1, hour: parseInt(get('hour'), 10) % 24, minute: parseInt(get('minute'), 10) };
  }

  class GelDispatch extends HTMLElement {
    connectedCallback() {
      this.eta = this.querySelector('.gel-dispatch__eta');
      this.cutoff = parseInt(this.dataset.cutoffHour || '16', 10);
      this.days = (this.dataset.days || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
      this.render();
      this.timer = setInterval(this.render.bind(this), 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    render() {
      if (!this.eta) return;
      var now = londonNow();
      var text;
      if (this.days.indexOf(now.day) > -1 && now.hour < this.cutoff) {
        var mins = (this.cutoff - now.hour) * 60 - now.minute;
        var h = Math.floor(mins / 60), m = mins % 60;
        text = ' – order within ' + (h ? h + 'h ' : '') + m + 'm for same-day dispatch';
      } else {
        var next = now.day, i = 0;
        do { next = next % 7 + 1; i++; } while (this.days.indexOf(next) === -1 && i < 7);
        var label = (next === now.day % 7 + 1) ? 'tomorrow' : DAY_NAMES[next - 1];
        text = ' – order now for dispatch ' + label;
      }
      this.eta.textContent = text;
      this.eta.hidden = false;
    }
  }
  customElements.define('gel-dispatch', GelDispatch);
})();

/* Gourmet E-Liquid – flavour grid: sold-out toggle and "Find a flavour" filter.
   The variant picker is re-rendered on every change, so state is kept per product/option. */
(function () {
  if (customElements.get('gel-flav-grid')) return;
  window.gelFlavOpen = window.gelFlavOpen || {};

  class GelFlavGrid extends HTMLElement {
    connectedCallback() {
      this.fieldset = this.closest('fieldset');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.gel-flav__item'));
      this.more = this.querySelector('[data-gel-flav-more]');
      this.empty = this.querySelector('[data-gel-flav-empty]');
      this.filter = this.fieldset ? this.fieldset.querySelector('[data-gel-flav-filter]') : null;
      this.key = this.dataset.key;

      this.setOpen(!!window.gelFlavOpen[this.key]);
      if (this.more) {
        this.more.addEventListener('click', () => {
          window.gelFlavOpen[this.key] = !this.classList.contains('is-open');
          this.setOpen(window.gelFlavOpen[this.key]);
        });
      }
      if (this.filter && !this.filter.dataset.bound) {
        this.filter.dataset.bound = '1';
        // Keep typing out of the variant picker's change handler and the product form
        this.filter.addEventListener('change', (e) => e.stopPropagation());
        this.filter.addEventListener('keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
        this.filter.addEventListener('input', () => this.applyFilter());
      }
      this.applyFilter();
    }

    setOpen(open) {
      this.classList.toggle('is-open', open);
      if (!this.more) return;
      this.more.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.more.querySelector('[data-label-closed]').hidden = open;
      this.more.querySelector('[data-label-open]').hidden = !open;
    }

    applyFilter() {
      const q = this.filter ? this.filter.value.trim().toLowerCase() : '';
      this.classList.toggle('is-filtering', q !== '');
      let shown = 0;
      this.items.forEach((item) => {
        const match = !q || item.dataset.name.indexOf(q) > -1;
        item.classList.toggle('is-filtered-out', !match);
        if (match) shown += 1;
      });
      if (this.empty) this.empty.hidden = shown > 0;
    }
  }
  customElements.define('gel-flav-grid', GelFlavGrid);
})();
